import React from "react"
import PropTypes from "prop-types"
import { motion } from "framer-motion"
import { Col, Row, Card, CardBody, Spinner } from "reactstrap"
import formatNumber from "./formatNumber"

const MiniWidgetProcesso = ({ movimentacoes, loading }) => {
  const getIcon = count => {
    if (count > 0) return "mdi mdi-chevron-up"
    if (count < 0) return "mdi mdi-chevron-down"
    return "mdi mdi-minus"
  }

  const getGradient = count => {
    if (count > 0) {
      return "linear-gradient(135deg, #53B947 0%, #169F85 100%)"
    } else if (count === 0) {
      return "linear-gradient(135deg, #8E96A3 0%, #6C757D 100%)"
    } else {
      return "linear-gradient(135deg, #FF5C75 0%, #DC3545 100%)"
    }
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const cardVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  }

  const numberVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  }

  return (
    <div className="dashboard-stats">
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <Card className="shadow-lg border-0 rounded-lg">
          <CardBody>
            <Row className="mb-4">
              <Col lg="12">
                <h3 className="text-gradient fw-bold">Movimentações</h3>
              </Col>
            </Row>
            <Row>
              {movimentacoes.map((mov, index) => (
                <Col sm="3" key={index}>
                  <motion.div variants={cardVariants}>
                    <Card
                      className="stat-card border-0 h-100"
                      style={{
                        background: getGradient(mov.newTodayCount),
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      }}
                    >
                      <CardBody className="p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div className="stat-icon me-3">
                            <span className="rounded-circle bg-transparent-icon text-white">
                              <i className={`${mov.icon} fs-4`} />
                            </span>
                          </div>

                          <h5 className="text-white mb-0 fw-semibold">
                            {mov.title}
                          </h5>
                        </div>
                        <div className="mt-4">
                          <motion.div
                            variants={numberVariants}
                            className="d-flex align-items-center"
                          >
                            <h2 className="text-white mb-0 me-2 fw-bold">
                              {loading ? (
                                <Spinner size="sm" color="light" />
                              ) : (
                                <>
                                  {formatNumber(mov.total)}{" "}
                                  <i
                                    className={`${getIcon(
                                      mov.newTodayCount
                                    )} ms-1`}
                                  />
                                </>
                              )}
                            </h2>
                          </motion.div>
                          <div className="mt-3 d-flex gap-2">
                            <span className="badge bg-transparent-10 text-white px-3 py-2">
                              <strong>
                                {loading ? (
                                  <Spinner size="sm" color="light" />
                                ) : (
                                  formatNumber(mov.newTodayCount)
                                )}
                              </strong>{" "}
                              Hoje
                            </span>
                            <span className="badge bg-transparent-20 text-white px-3 py-2">
                              <strong>
                                {loading ? (
                                  <Spinner size="sm" color="light" />
                                ) : (
                                  formatNumber(mov.newMonthCount)
                                )}
                              </strong>{" "}
                              no Mês
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </motion.div>

      <style>
        {`
          .dashboard-stats .stat-card {
            transition: transform 0.3s ease;
          }
          
          .dashboard-stats .stat-card:hover {
            transform: translateY(-5px);
          }
          
          .dashboard-stats .stat-icon span {
            width: 48px;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .text-gradient {
            background: linear-gradient(135deg, #333 0%, #666 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          
          .rounded-lg {
            border-radius: 1rem !important;
          }

          .bg-transparent-icon {
            background-color: rgba(255, 255, 255, 0.15);
          }

          
          .bg-transparent-10 {
            background-color: rgba(255, 255, 255, 0.1);
          }

          .bg-transparent-20 {
            background-color: rgba(255, 255, 255, 0.2);
          }

        `}
      </style>
    </div>
  )
}

MiniWidgetProcesso.propTypes = {
  movimentacoes: PropTypes.array,
}

export default MiniWidgetProcesso
